import { FreeSpinsInfoEvent } from '@cgs/data-access';
import { BaseReelsSlotGame, ExtendedSlotGameParams, SlotGameBuilder } from '@cgs/machines';
import {
  ApplicationGameConfig,
  ApplicationUserConfig,
  EnvironmentConfig,
  Logger,
} from '@cgs/shared';
import {
  initLaunchParams,
  TRIFECTA_LAUNCH_PARAMS_TOKEN,
  TrifectaLaunchParamsDto,
  mountRoundInfoFrame,
} from '@cgs/provider-trifecta';
import { Container, InstanceLifetime, PlatformSettings, Preloader, ResizeMode } from '@cgs/wge';
import packageJson from '../package.json';
import '../styles/main.css';
import { santaGameSettings } from './santa-game-settings';
import { SantaGameProviderTrifecta } from './santa-game-provider-trifecta';

async function initAppSettings(): Promise<TrifectaLaunchParamsDto> {
  const launchParams = window.launchParams as TrifectaLaunchParamsDto;

  if (!launchParams) {
    throw new Error('Failed to extract launchParams from HTML');
  }

  console.log('launchParams', launchParams);

  if (launchParams.replayData !== undefined) {
    initLaunchParams(launchParams, 20);
  }

  const gameId = launchParams.game.replace('sweatshop', '');

  ApplicationGameConfig.init({
    currency: launchParams.currencyId,
    gameId: gameId,
    machineId: launchParams.initData.machineState?.machineId.toString() || '7',
    appVersion: packageJson.version,
  });

  EnvironmentConfig.init({
    api: {
      url: '',
    },
    isCheatEnabled: ENVIRONMENT_CONFIG?.isCheatEnabled || false,
  });

  ApplicationUserConfig.init({
    session: launchParams.gameSession,
    cheatUser: launchParams.initData.isCheatUser,
    userId: '',
    language: launchParams.languageId,
  });

  if (launchParams.resumeData !== undefined) {
    launchParams.isRecovery =
      launchParams.resumeData.spins.length !== 1 &&
      launchParams.resumeData.spins[0].freeSpinsInfo?.event !==
        FreeSpinsInfoEvent.FreeSpinsFinished;
  }

  return launchParams;
}

window.onload = async () => {
  const canvas = document.getElementById('app-canvas') as HTMLCanvasElement;

  if (!canvas) {
    throw new Error('Cannot find root canvas element!');
  }

  Logger.Initialize();
  Logger.Debug('Logger initialized');

  const settings = new PlatformSettings(false, false, false, ResizeMode.Resize);
  settings.preloader = new Preloader(canvas, '#splashContainer');

  const launchParams = await initAppSettings();

  console.log('[round-info] replayData:', launchParams.replayData);

  if (launchParams.replayData?.type === 'static') {
    console.log('[round-info] mounting round-info iframe');
    mountRoundInfoFrame({
      gameId: 'Santa',
      currencyId: launchParams.currencyId,
      currencyDecimals: launchParams.currencyDecimals,
      symbolsPath: 'staticReplay/symbols',
      replayData: launchParams.replayData,
      operatorId: (launchParams as any).operatorId,
    });
    return;
  }

  const container = new Container();

  launchParams.buyFeatureMultiplier = 100;
  launchParams.buyBonusRtp = 93.6;
  launchParams.hitRate = 28.78;
  launchParams.volatility = '5/5';

  container.registerValue(TRIFECTA_LAUNCH_PARAMS_TOKEN, launchParams, {
    lifetime: InstanceLifetime.Singleton,
  });

  const slotParams = new ExtendedSlotGameParams(ApplicationGameConfig.machineId, 6, 6, 65, [], {
    iconsWithValuesEnabled: true,
    epicWinAfterShortWinLines: true,
    stbEnabled: true,
  });

  const gameServerProvider = new SantaGameProviderTrifecta(container);

  new SlotGameBuilder(
    window,
    canvas,
    settings,
    santaGameSettings,
    container,
    () => new BaseReelsSlotGame(container, slotParams),
    gameServerProvider
  ).build();
};
